import Model from './Model'
import VehicleLog from './VehicleLog'
import { toFormData } from '@utils'

export default class Vehicle extends Model
{
    filled () {
        if (this.logs?.data) this.logs.data = VehicleLog.make(this.logs.data)
    }

    totalLeasePayment () {
        const advance = parseFloat(this.lease_advance_payment) || 0
        const finalP = parseFloat(this.lease_final_payment) || 0
        const regulars = parseFloat(this.lease_followed_by_value) || 0
        const amountofRegulars = parseFloat(this.lease_followed_by_number) || 0
        const total = (advance + finalP + (regulars * amountofRegulars))

        return total.toFixed(2)
    }

    getFormAttributes () {
        const attributes = this.except([
            'driver_id', 'driver_name', 'lease_company_id', 'lease_company_name',
            'lease_followed_by_frequency', 'lease_followed_by_frequency_uc',
            'mileagelogs', 'logs', 'previousdrivers',
        ])

        attributes.driver = { value: this.driver_id, label: this.driver_name || 'Not Set' }
        attributes.lease_company = { value: this.lease_company_id, label: this.lease_company_name || 'Not Set' }
        attributes.lease_freq = { value: this.lease_followed_by_frequency, label: this.lease_followed_by_frequency_uc || 'Not Set' }

        return attributes
    }

    static parseAttributes (attributes) {
        attributes.driver_id = attributes.driver?.value || null
        attributes.driver_name = attributes.driver?.label || 'Not Set'
        delete attributes['driver']
        attributes.lease_company_id = attributes.lease_company?.value || null
        attributes.lease_company_name = attributes.lease_company?.label || 'Not Set'
        delete attributes['lease_company']
        attributes.lease_followed_by_frequency = attributes.lease_freq?.value || null
        attributes.lease_followed_by_frequency_uc = attributes.lease_freq?.label || 'Not Set'
        delete attributes['lease_freq']

        return attributes
    }

    static async all () {
        const { data } = await Http.get(route('api.v1.vehicles.index'))
        return this.make(data)
    }

    static async search (query) {
        const params = { query }
        const { data } = await Http.get(route('api.v1.vehicles.index'), { params })
        return this.make(data)
    }

    static async find (id) {
        const { data } = await Http.get(route('api.v1.vehicles.show', id))
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.vehicles.store')
        const payload = this.parseAttributes(attributes)
        const { data } = await Http.post(url, toFormData(payload))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.vehicles.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, toFormData(payload))
        return this.fill(data)
    }

    async updateMileage (attributes = {}) {
        const url = route('api.v1.vehicles.mileage.update', this.id)
        const { data } = await Http.post(url, attributes)
        return this.fill(data)
    }

    toDropdown() {
        return { label: this.vrn+ ' ('+this.make+' '+this.model+')', value: this.key() }
    }

    async updateDriver (attributes = {}) {
        const url = route('api.v1.vehicles.mileage.update', this.id)
        const { data } = await Http.post(url, attributes)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.vehicles.destroy', this.id))
    }
}
